import { Header, headerConfigDefaults } from '@qga/components';
import { useSelector } from 'react-redux';
import { getAuthentication, getIsSSOLoginScreenVisible } from 'store/authentication/selectors';
import { getQffAuth } from 'lib/qffAuth';
import { createEventCreator } from 'lib/gaTracking/ga';

const handleInteraction = createEventCreator((info: { type: string; value: string }) => ({ action: info.value, category: info.type }));

export default function GlobalHeader() {
  const { ssoUser } = useSelector(getAuthentication);
  const isSSOLoginScreenVisible = useSelector(getIsSSOLoginScreenVisible);

  const authAPI = getQffAuth();

  const handleClickLogin = () => {
    if (!isSSOLoginScreenVisible) {
      authAPI?.showLoginModal();
    }
  };

  return (
    <Header
      {...headerConfigDefaults}
      qffAuthData={ssoUser}
      onClickLogin={handleClickLogin}
      onClickLogout={authAPI?.logout}
      onInteraction={handleInteraction}
    />
  );
}
